/**
 * created by li si yi
 * 账号冻结
 */
import React, {Component} from 'react';
import {Button, InputNumber, message, Tabs, Pagination} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import PropTypes from "prop-types";
import BaseTable from "../../components/baseTable/BaseTable";
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";

const {TabPane} = Tabs;
let height = window.innerHeight - 110;
export default class SuspendAccount extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabBarList: [ // 选项卡数据
                {
                    key: '0',
                    name: '冻结记录',
                    url: '/cm-sites-sys/frozen/list',
                    module: 'renderTable',
                    method: 'get',
                    params: {
                        start: 1,//分页
                        size: 10,
                    },
                    errorcount: 0,
                    dataSource: {}
                },
                {
                    key: '1',
                    name: '冻结设置',
                    url: '/cm-sites-sys/frozen/getRule',
                    module: 'renderSetSuspend',
                    method: 'get',
                    params: {},
                    dataSource: {}
                }
            ],
            columns: [
                {
                    title: '用户账号',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '封禁开始时间',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    render: (text) => {
                        let startTime = moment(text).format('YYYY-MM-DD') + " " + moment(text).format('LTS');
                        return (
                            <div>
                                {startTime}
                            </div>
                        )
                    }
                },
                {
                    title: '封禁周期',
                    dataIndex: 'cycle',
                    key: 'cycle',
                    render: (text) => {
                        return (
                            <span>{text}分钟</span>
                        )
                    }
                },
                {
                    title: '当前状态',
                    dataIndex: 'status',
                    key: 'status',
                    render: (text) => {
                        return (
                            <span>{text == 0 ? '已恢复正常状态' : '冻结中'}</span>
                        )
                    }
                },
                {
                    title: '操作',
                    render: (text, record) => {
                        return (
                            record.status == 0 ? null :
                                <span style={{color: 'rgb(24, 144, 255)', cursor: 'pointer'}} onClick={() => {
                                    this.lift(record)
                                }}>解冻</span>
                        )
                    }
                },
            ],
            thisTabKey: '0',// 选项卡当前选中项
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDataSource();
    }

    componentWillUnmount() {
    }

    // 分页改变
    pageChange = (start, size) => {
        let {tabBarList, thisTabKey} = this.state;
        // 获取当前tab参数
        let thistab = tabBarList.find(item => item.key === thisTabKey);
        thistab.params.start = start;
        thistab.params.size = size;
        this.getDataSource();
    };
    // 选项卡改变
    changeTabBar = (key) => {
        this.state.thisTabKey = key;
        this.getDataSource();
    }
    // 保存修改
    saveSetting = () => {
        this.setRule()
    }

    render() {
        return (
            <div className="card-container" style={{marginTop: '15px', marginLeft: '15px', maxHeight: "calc(100vh - 100px)", borderRadius: "0 5px"}}>
                {/*选项卡*/}
                {this.renderTabBar()}
                {/*渲染选中内容*/}
                {this.renderContent()}
            </div>
        )
    }

    // 选项卡
    renderTabBar = () => {
        return (
            <Tabs type="card" onChange={this.changeTabBar}>
                {
                    this.state.tabBarList.map((item) => {
                        return (
                            <TabPane tab={item.name} key={item.key} style={{backgroundColor: '#fff'}}/>
                        )
                    })
                }
            </Tabs>
        )
    }
    // 选项卡内容
    renderContent = () => {
        const {thisTabKey} = this.state;
        const module = this.state.tabBarList.find(item => item.key === thisTabKey)['module'];
        return this[module]()
    }
    // 冻结记录表
    renderTable = () => {
        let {tabBarList, thisTabKey} = this.state;
        // 获取当前tab参数
        let thistab = tabBarList.find(item => item.key === thisTabKey);
        return (
            <div style={{
                backgroundColor: '#fff',
                borderBottomLeftRadius: '5px',
                borderBottomRightRadius: '5px',
            }}>
                <div style={{padding: '24px',maxHeight: "calc(100vh - 221px)"}} className={"suspendAccount"}>
                    <Scrollbars autoHeight autoHeightMax={"calc(100vh - 269px)"}>
                        <BaseTable rowKey="id" dataSource={thistab.dataSource['data']} columns={this.state.columns}
                                   pagination={false}/>

                    </Scrollbars>
                    <style>{`
                    .suspendAccount .ant-table-placeholder{
                       display:flex;
                       justify-content: center;
                       align-items: center;
                    //    height:545px;
                       border:none;
                    }
                `}</style>
                </div>
                {/*分页*/}
                {this.renderPagination()}
            </div>
        )
    };
    // 冻结设置
    renderSetSuspend = () => {
        let {tabBarList, thisTabKey} = this.state;
        // 获取当前tab参数
        let thistab = tabBarList.find(item => item.key === thisTabKey);
        let {errorcount, accountfrozentime} = thistab.dataSource;
        return (
            <div style={{backgroundColor: '#fff', padding: '0 32px', paddingBottom: "15px", maxHeight: "calc(100vh - 140px)",borderBottomLeftRadius:'5px',borderBottomRightRadius:'5px'}}>
                <div style={{color: '#000', fontWeight: '600', padding: '24px 0 14px 0'}}>自动冻结策略设置</div>
                <div className={'suspendAccount'}>五分钟内密码连续输错
                    <InputNumber style={{margin: '0 5px'}} min={0} defaultValue={errorcount} precision={0} maxLength={5}
                                 value={errorcount}
                                 parser={value => value.replace(/\D/g, '')}
                                 onChange={(value) => {
                                     value == undefined ? thistab.dataSource.errorcount = 0 : thistab.dataSource.errorcount = value
                                     this.setState({})
                                 }}/>次 则冻结账号
                    <InputNumber style={{margin: '0 5px'}} min={0} defaultValue={accountfrozentime} precision={0}
                                 value={accountfrozentime} maxLength={5}
                                 parser={value => value.replace(/\D/g, '')}
                                 onChange={(value) => {
                                     value == undefined ? thistab.dataSource.accountfrozentime = 0 : thistab.dataSource.accountfrozentime = value
                                     this.setState({})
                                 }}/>分钟，为空则不冻结
                    <Button style={{
                        backgroundColor: '#0050B3',
                        width: '64px',
                        height: '32px',
                        marginLeft: '32px',
                    }} onClick={this.saveSetting}>保存</Button>
                    <style>
                        {`
                        .suspendAccount .ant-btn{
                            color: #fff !important;
                        }
                        `}
                    </style>
                </div>
            </div>
        )
    }
    // 分页
    renderPagination = () => {
        let {tabBarList, thisTabKey} = this.state;
        // 获取当前tab参数
        let thistab = tabBarList.find(item => item.key === thisTabKey);
        let {start, size} = thistab.params;
        let {count} = thistab.dataSource;
        return (
            <div className={'pagination'} >
                <div style={{padding: "0 10px 0"}}>共{count}条数据</div>
                <Pagination
                    showSizeChanger
                    current={start}
                    pageSize={size}
                    total={count}
                    showQuickJumper={true}
                    onChange={this.pageChange}
                    onShowSizeChange={this.pageChange}
                />
            </div>
        )
    }
    // 获取选项卡内容数据
    getDataSource = () => {
        let {tabBarList, thisTabKey} = this.state;
        // 获取当前tab参数
        let thistab = tabBarList.find(item => item.key === thisTabKey);
        this.request({
            url: thistab.url,
            method: thistab.method,
            body: thistab.params,
            callBack: (res) => {
                let errorcount = 0
                let dataSource = {};
                if (res) {
                    dataSource = res
                } else {
                    message.error("数据获取失败！");
                }
                thistab.dataSource = res;
                this.setState({errorcount});
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 修改
    setRule = () => {
        let {tabBarList, thisTabKey} = this.state;
        let url = '/cm-sites-sys/frozen/setRule';
        // 获取当前tab参数
        let thistab = tabBarList.find(item => item.key === thisTabKey);
        let params = thistab.dataSource;
        this.request({
            url,
            body: params,
            callBack: (res) => {
                if (res) {
                    message.success("保存成功");
                } else {
                    message.error("保存失败！");
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        })
    }
    // 解绑
    lift = (record) => {
        let url = '/cm-sites-sys/frozen/lift';
        // 获取当前tab参数
        let params = {account: record.account};
        this.request({
            url,
            method: 'get',
            body: params,
            callBack: (res) => {
                if (res) {
                    message.success("解冻成功");
                    this.getDataSource()
                } else {
                    message.error("解冻失败！");
                }
                //刷新页面
                // this.setState({})
                this.getDataSource()
            },

            errorCallBack: (e) => {
                console.log(e)
            }
        })
    }
};

SuspendAccount.defaultProps = {};
SuspendAccount.propTypes = {};